import str from './string';
let cookie = {
  set: (name, value, domain, expires?: string) => {
    if (document?.cookie) {
      var d = new Date();
      d.setTime(d.getTime() + 360 * 24 * 60 * 60 * 1000);
      if (!expires && document) {
        //未设置过期时间，默认为session级别
        document.cookie = name + '=' + value + ';path=/;domain=' + domain;
      } else {
        if (document) {
          document.cookie = name + '=' + value + ';path=/;domain=' + domain + ';expires=' + expires;
        }
      }
    }
  },
  get: (name) => {
    if (document.cookie) {
      var cookie = document && document.cookie;
      var s = str.removeBlanks(cookie);
      var pairs = s && s.split(';');
      if (pairs) {
        for (var i = 0; i < pairs.length; i++) {
          var pairSplit = pairs[i].split('=');
          if (pairSplit.length > 1 && pairSplit[0] === name) {
            return pairSplit[1];
          }
        }
      }
      return '';
    } else {
      return ''
    }
  },
  del: (name) => {
    var exp = new Date();
    exp.setTime(exp.getTime() + (-1 * 24 * 60 * 60 * 1000));
    var cval = cookie.get(name);
    document.cookie = name + "=" + cval + "; expires=" + exp.toUTCString();
  }
}
export default cookie;
